/**
 * バージョン情報を取得する
 * @returns バージョン文字列
 */
export const getAppVersion = (): string => {
  return import.meta.env.VITE_APP_VERSION || "unknown";
};

/**
 * コミットハッシュを取得する
 * @returns コミットハッシュ
 */
export const getCommitHash = (): string => {
  return import.meta.env.VITE_COMMIT_HASH || "unknown";
};
